/* eslint-disable react/prop-types */
import { Breadcrumb as Breadcrumbs } from 'react-bootstrap'
import '../../styles/Breadcrumb.scss';
import Link from './Link';

function Breadcrumb(props) {
  return (
    <Breadcrumbs>
      <Breadcrumbs.Item linkAs={Link} linkProps={{ to: "/dashboard" }}>Home</Breadcrumbs.Item>
      {props.pages ?
        props.pages.map((e, i) => {
          return (
            e.link ?
              <Breadcrumbs.Item key={i} linkAs={Link} linkProps={{ to: '/' + e.link }}>
                {e.title}
              </Breadcrumbs.Item>
              :
              <Breadcrumbs.Item key={i} active>{e.title}</Breadcrumbs.Item>
          )
        })
        : ''}
      {props.active && <Breadcrumbs.Item active>{props.active}</Breadcrumbs.Item>}
    </Breadcrumbs>
  );
}

export default Breadcrumb;